import {Badge} from '@mantine/core';

import {SetupIntentStatus} from '../types';

/**
 * FNP-918: setup-intent status as a themed badge (§13).
 *
 * ⚠️ The colours were HARDCODED BOOTSTRAP HEX (`#6c757d`, `#007bff`, …), which
 * ignores the Mantine theme entirely: they do not shift for dark mode, do not
 * follow a theme override, and cannot be restyled centrally. They are now
 * Mantine palette tokens.
 *
 * ⚠️ Two of the old hexes were `#28a745` (requiresAction) and `#28a748`
 * (succeeded) — one digit apart, almost certainly a typo, and visually
 * IDENTICAL. So the state that needs an operator to intervene rendered the same
 * green as the state that is finished and needs nothing. The mapping below
 * makes that distinction visible: succeeded is green, requiresAction is orange.
 *
 * The semantics: green = done, orange/yellow = waiting on someone, blue = in
 * flight, grey = terminal-but-not-successful.
 */
const STATUS_COLORS: Record<string, string> = {
    [SetupIntentStatus.succeeded]: 'green',
    [SetupIntentStatus.processing]: 'blue',
    [SetupIntentStatus.requiresAction]: 'orange',
    [SetupIntentStatus.requiresConfirmation]: 'yellow',
    [SetupIntentStatus.requiresPaymentMethod]: 'cyan',
    [SetupIntentStatus.canceled]: 'gray',
};

export const StatusBadge = ({status}: {status: string}) => {
    // An unrecognised status still renders, in a neutral colour, rather than
    // falling through to an undefined colour prop (§13). A new enum member
    // added upstream shows up as a plain badge, not a broken one.
    return (
        <Badge color={STATUS_COLORS[status] ?? 'gray'} variant='light'>
            {status}
        </Badge>
    );
};
